import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback } from "react";
import acceptCig, { AcceptCIGRes } from "../acceptCig";

const useAcceptCig = (cigId?: string, accept?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<AcceptCIGRes | null>(null);

  const send = useCallback(async () => {
    if (cigId == null || accept == null) return reqState;
    setLoading();
    try {
      const acceptRes = await acceptCig(cigId, accept);
      return setSuccess(acceptRes);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [cigId, accept, reqState, setError, setLoading, setSuccess]);

  return { ...reqState, data: reqState.data, send };
};

export default useAcceptCig;
